import { ComponentFactoryResolver, ComponentRef, ViewContainerRef, Directive, Input } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[appDynamicComponent]'
})
export class DynamicComponentDirective {
  @Input() components!: any;
  @Input() instanceData!: any;

  constructor(private container: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnChanges() {
    if (this.components) {
      this.loadComponents();
    }
  }

  loadComponents() {
    const factory = this.componentFactoryResolver.resolveComponentFactory(this.components);
    const componentRef: ComponentRef<any> = this.container.createComponent(this.components);
    this.updateInstanceValue(componentRef);
  }

  updateInstanceValue(componentRef: any) {
    for (let prop in this.instanceData) {
      if (componentRef.instance[prop]) {
        componentRef.instance[prop] = this.instanceData[prop];
      }
    }
  }
}
